export default "__VITE_ASSET__CxFBkCbK__"